import { render, staticRenderFns } from "./NationalEventsComponent.vue?vue&type=template&id=45ab8fca&"
import script from "./NationalEventsComponent.vue?vue&type=script&lang=ts&"
export * from "./NationalEventsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports